var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.391,
    height: 8.927,
    viewBox: "0 0 13.391 8.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "left",
    d: "M6.7,8.927,0,2.049,1.994,0,6.7,4.83,11.4,0l1.994,2.049Z",
    fill: "#feffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownOutlined);
export default __webpack_public_path__ + "static/media/DownOutlined.46ad7cd5f5cbb36c2e276143186f3175.svg";
export { ForwardRef as ReactComponent };